import { ColDef } from "ag-grid-community";

// import { GFCMoreOptions, GFCServiceType } from "./GridFrameworkComponents";

const columnDef: ColDef[] = [
    {
        headerName: "Id",
        field: "Id",
        sortable: true,
        filter: true,
        resizable: true,
        //flex: 1,
        width: 350,
        headerStyle: { paddingLeft: "24px" },
        cellStyle: { paddingLeft: "24px" },
    },
    {
        headerName: "First Name",
        field: "FirstName",
        sortable: true,
        filter: true,
        resizable: true,
    },
    {
        headerName: "Last Name",
        field: "LastName",
        sortable: true,
        resizable: true,
    },
    {
        headerName: "Email",
        field: "Email",
        sortable: true,
        resizable: true,
        flex: 1,
    },
    {
        headerName: "Created At",
        field: "CreatedAt",
        sortable: true,
        resizable: true,
        flex: 1,
    },
    {
        headerName: "Last Update",
        field: "UpdatedAt",
        sortable: true,
        resizable: true,
        flex: 1,
    },
];

export { columnDef };
